<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="flex flex-col gap-4 flex-1 min-h-0"
>
  <div class="grid grid-cols-2 gap-4">
    <et-atoms-input class="w-full col-span-2">
      <label>Signer name</label>
      <input etAtomsInput formControlName="signerName" type="text" required />
      @if ( form.controls['signerName'].touched &&
      form.controls['signerName'].invalid ) {
      <span etAtomsInputError>Signer name is required</span>
      }
    </et-atoms-input>

    <et-atoms-input class="w-full col-span-2">
      <label>Signer address</label>
      <input etAtomsInput formControlName="signerAddress" type="text" />
    </et-atoms-input>

    <et-atoms-select-field class="w-full">
      <label>Signer state</label>
      <et-atoms-select-input formControlName="signerState">
        @for (option of stateOptions; track option.name) {
        <et-atoms-select-option [value]="option.name">
          {{ option.name }}
        </et-atoms-select-option>
        }
      </et-atoms-select-input>
    </et-atoms-select-field>

    <et-atoms-select-field class="w-full">
      <label>Method of identification verification</label>
      <et-atoms-select-input formControlName="identificationMethod">
        @for (opt of identificationMethodOptions; track opt.value) {
        <et-atoms-select-option [value]="opt.value">
          {{ opt.label }}
        </et-atoms-select-option>
        }
      </et-atoms-select-input>
    </et-atoms-select-field>
  </div>

  @if (form.controls['identificationMethod'].value === 'identification_cards') {
  <div class="grid grid-cols-2 gap-4">
    <et-atoms-input class="w-full">
      <label>ID type</label>
      <input etAtomsInput formControlName="signerIdType" type="text" />
    </et-atoms-input>

    <et-atoms-input class="w-full">
      <label>ID number</label>
      <input etAtomsInput formControlName="signerIdNumber" type="text" />
    </et-atoms-input>

    <div class="relative w-full">
      <label class="block mb-1 text-sm font-medium">ID issue date</label>
      <input
        interfacePreventTyping
        formControlName="signerUtcIdIssuedOn"
        [dpDayPicker]="datePickerConfig"
        placeholder="ID issue date"
        class="w-full text-base font-medium bg-transparent text-midnight input input-bordered placeholder-secondary-focus focus:outline-midnight focus:border-transparent focus:outline-offset-0"
      />
    </div>

    <div class="relative w-full">
      <label class="block mb-1 text-sm font-medium">ID expiration date</label>
      <input
        interfacePreventTyping
        formControlName="signerUtcIdExpiresOn"
        [dpDayPicker]="datePickerConfig"
        placeholder="ID expiration date"
        class="w-full text-base font-medium bg-transparent text-midnight input input-bordered placeholder-secondary-focus focus:outline-midnight focus:border-transparent focus:outline-offset-0"
      />
    </div>
  </div>
  } @if (form.controls['identificationMethod'].value === 'personal_knowledge') {
  <div class="grid gap-4">
    <div class="px-[2px]">
      <label class="block mb-1 text-sm font-medium">
        Statement of personal knowledge
      </label>
      <textarea
        formControlName="signerPersonalKnowledgeStatement"
        rows="4"
        class="w-full px-6 py-3 font-medium border rounded-lg focus:outline-midnight text-midnight"
      ></textarea>
    </div>
  </div>
  } @if (form.controls['identificationMethod'].value === 'credible_witnesses') {
  <div class="grid grid-cols-2 gap-4">
    <et-atoms-input class="w-full col-span-2">
      <label>Witness name</label>
      <input etAtomsInput formControlName="signerWitnessName" type="text" />
    </et-atoms-input>

    <et-atoms-input class="w-full">
      <label>Witness ID type</label>
      <input etAtomsInput formControlName="signerWitnessIdType" type="text" />
    </et-atoms-input>

    <et-atoms-input class="w-full">
      <label>Witness ID info</label>
      <input etAtomsInput formControlName="signerWitnessIdInfo" type="text" />
    </et-atoms-input>
  </div>
  }
  <!-- Error message -->
  @if (error) {
  <p class="text-error my-2">{{ error }}</p>
  } @if (!hideButtons) {
  <div class="flex flex-wrap justify-end gap-4">
    <button
      type="button"
      class="normal-case rounded-full btn btn-outline min-w-[184px] text-base"
      mat-dialog-close
      [disabled]="isLoading"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="normal-case rounded-full btn btn-primary min-w-[184px] text-base"
      [class.pointer-events-none]="isLoading"
    >
      @if (isLoading) {
      <et-atoms-spinner size="small"></et-atoms-spinner>
      } @else { Save }
    </button>
  </div>
  }
</form>
